import { uri } from '../../api-endpoint';
import { IAnnotationFromAPISuccessResponse } from '../../type-conversion/annotation/from-api-repsonse';
import { fetchListTemplateFn } from '../common';

export const fetchProjectImageAnnotationListAPI = (token: string) => (
  projectId: number,
  imageId: number
) =>
  fetchListTemplateFn(
    token,
    uri.projectImageAnnotationList(projectId, imageId),
    IAnnotationFromAPISuccessResponse
  );
